import { EFreelancerContractStatus, EFreelancerDutyType, ETaxSourceLocation, ETaxSourceRegister } from '../../types/app-account/freelancer';
import { EFaceAuth, EHnInvoiceType, EInvoiceTaxMethod, EProxyPayType, ETaxSourceType, IPageParam } from '../../types/common';

export interface ITaskListParam extends IPageParam {
  /** 任务编号 */
  dutyNo?: string;
  /** 任务名称 */
  dutyName?: string;
  /** 使用产品 */
  code?: string;

  /** 开始日期  */
  startTime?: string;
  /** 结束日期  */
  endTime?: string;
  /** 任务状态  */
  status?: ETaskStatus;
  /** 企业名称  */
  companyName?: string;
  /** 代理商名称  */
  agentName?: string;
  /** 业务类型 */
  dutyType?: EFreelancerDutyType;
  /** 关联代理商名称 */
  relatedAgentName?: string;
  /** 所属服务商名称  */
  serverName?: string;
  /** 收入性质 */
  proxyPayType?: EProxyPayType;
  /** 税源地类型(0-大陆 1-海南) */
  taxSourceType?: ETaxSourceType;
  /** 开票方式 */
  invoiceTaxMethod?: EInvoiceTaxMethod;
  /** 开票科目 */
  invoiceSubId?: number;
}

export interface ITaskListItem {
  /** id */
  id: number;
  /** 任务编号 */
  dutyNo?: string;
  /** 任务名称 */
  dutyName?: string;
  /** 任务类型 */
  tempName?: string;
  /** 任务佣金  */
  dutyCommission?: number;
  /** 使用产品 */
  code?: string;
  /** 产品名称 */
  productName?: string;
  /** 是否公开 1是 0否 */
  publicInMini?: EYesNo;
  /** 开始日期  */
  startTime?: string;
  /** 结束日期  */
  endTime?: string;
  /** 任务状态  */
  status?: ETaskStatus;
  /** 企业名称  */
  companyName?: string;
  /** 企业Id */
  companyId?: number;
  /** 代理商名称  */
  agentName?: string;
  /** 代理商Id */
  agentId?: number;
  /** 所属服务商名称  */
  serverName?: string;
  /**  绑定企业人员状态 */
  bindEmployeeStatus?: EBindEmployeeStatus;
  /** 税源地类型(0-大陆 1-海南) */
  taxSourceType?: ETaxSourceType;
  /** 是否需要上传交付物 0:否 1:是 */
  needDeliver?: EYesNo;
  /** 是否展示提示 0:否 1:是 */
  showTips?: EYesNo;
  /** 收入性质 */
  proxyPayType?: EProxyPayType;
  /** 开票方式 */
  invoiceTaxMethod?: EInvoiceTaxMethod;
  /** 海南开票方式 */
  hnInvoiceType?: EHnInvoiceType;
}

export interface ITaskTemplateParam extends IPageParam {
  companyName?: string;
  tempName?: string;
}

export interface ITaskTemplateItem {
  /** 企业名称 */
  companyName?: string;
  /** 任务模板 */
  templateName?: string;
  /** 所属行业 */
  industryName?: string;
  /** 授权状态  */
  authStatus?: number;
}

export interface ITaskTemplateAddParam { companyId?: string; templateId?: string }

export interface ITaskReceiveParam extends IPageParam {
  name?: string;
  idCard?: string;
  phone?: string;
}

export interface ITaskReceiveItem {
  /** 人员姓名 */
  name?: string;
  /** 身份证号 */
  idCard?: string;
  /** 手机号 */
  phone?: string;
  /** 银行卡号  */
  bankCard?: string;
  /** 是否实名 1是 0否 */
  isRealName?: EIsRealName;
  /** 自雇者协议 */
  isSign?: number;
  /** 接包方式  */
  receiveType?: number;
  /** 关联订单  */
  orderNos?: string;
  /** 任务状态  */
  taskStatus?: string;
}

/** 是否实名 */
export enum EIsRealName {
  /** 是 */
  Yes = 1,
  /** 否 */
  No = 0,
}

export const isRealNameLabel = {
  [EIsRealName.Yes]: '是',
  [EIsRealName.No]: '否',
};

/** 任务状态 */
export enum ETaskStatus {
  /** 审批中 */
  Audit = 0,
  /** 已驳回 */
  Reject = 1,
  /** 进行中 */
  Action = 2,
  /** 已完结 */
  Finish = 3,
}

export const taskStatusLabel = {
  [ETaskStatus.Audit]: '审批中',
  [ETaskStatus.Reject]: '已驳回',
  [ETaskStatus.Action]: '进行中',
  [ETaskStatus.Finish]: '已完结',
};

export const taskStatusStyle = {
  [ETaskStatus.Audit]: 'primary',
  [ETaskStatus.Reject]: 'danger',
  [ETaskStatus.Action]: 'success',
  [ETaskStatus.Finish]: 'info',
};

/** 授权状态 */
export enum ETaskAuthStatus {
  /** 是 */
  Yes = 1,
  /** 否 */
  No = 0,
}

export const taskAuthLabel = {
  [ETaskAuthStatus.Yes]: '已授权',
  [ETaskAuthStatus.No]: '未授权',
};

export const taskAuthStyle = {
  [ETaskAuthStatus.Yes]: 'success',
  [ETaskAuthStatus.No]: 'danger',
};

/**
 * 任务模板授权分页查询参数
 */
export interface ITaskTemplateAuthPageRequest extends IPageParam {
  /** 企业名称 */
  companyName?: string;
  /** 任务模板名称 */
  tempName?: string;
  /** 业务类型 */
  dutyType?: EFreelancerDutyType;
  /** 收入性质 */
  proxyPayType?: EProxyPayType;
}

/**
 * 任务模板授权分页列表项
 */
export interface ITaskTemplateAuthPageItem {
  /** 主键id */
  id: number;
  /** 模板id */
  tempId: number;
  /** 任务模板名称 */
  tempName: string;
  /** 企业名称 */
  companyName: string;
  /** 所属行业名称 */
  industryName: string;
  /** 状态 0:未授权 1:已授权 */
  status: number;
  /** 创建时间 */
  createTime: string;
}

/**
 * 任务模板授权分页响应
 */
export interface ITaskTemplateAuthPageResponse {
  /** 响应码 */
  code: number;
  /** 分页数据 */
  context: {
    /** 数据列表 */
    data: ITaskTemplateAuthPageItem[];
    /** 总数 */
    total: number;
  };
  /** 响应消息 */
  message?: string;
  /** 追踪ID */
  traceId?: string;
  /** 跨度ID */
  spanId?: string;
}

/**
 * 任务模板授权操作请求
 */
export interface ITaskTemplateAuthOperateRequest {
  /** 主键id */
  id: number;
  /** 操作类型 */
  type: ETaskTemplateAuthOperationType;
}

/**
 * 任务模板授权操作响应
 */
export interface ITaskTemplateAuthOperateResponse {
  /** 响应码 */
  code: number;
  /** 响应内容 */
  context: Record<string, never>;
  /** 响应消息 */
  message?: string;
  /** 追踪ID */
  traceId?: string;
  /** 跨度ID */
  spanId?: string;
}

/**
 * 任务模板授权操作类型
 */
export enum ETaskTemplateAuthOperationType {
  /** 0: 停止授权 */
  Revoke = 0,
  /** 1: 授权 */
  Grant = 1,
  /** 2: 删除 */
  Delete = 2
}

/**
 * 任务创建请求
 */
export interface ICreateTaskRequest {
  id?: number;
  /** 任务类型id(任务模版id) */
  tempId: number;
  /** 任务名称 */
  dutyName: string;
  /** 任务开始时间 格式yyyy-MM-dd */
  startTime: string;
  /** 任务结束时间 格式yyyy-MM-dd */
  endTime: string;
  /** 产品id */
  productId: number;
  /** 开票科目id */
  invoiceSubId: number;
  /** 开票科目（服务商给企业）id */
  hnInvoiceSubId?: number;
  /** 签约方式 */
  signType: ESignType;
  /** 任务内容说明 */
  description: string;
  /** 是否在小程序公开 */
  publicInMini: EYesNo;
  /** 是否需要报名 */
  signUpRequired: EYesNo;
  /** 岗位需求人数 */
  jobNum: number;
  /** 酬劳方式 */
  remunerationType: ERenumerationType;
  /** 指定金额/金额范围开始区间 */
  startAmount?: number;
  /** 金额范围结束区间 */
  endAmount?: number;
  /** 任务地点 */
  dutyAddressType: EDutyAddressType;
  /** 任务所在区域 */
  dutyAddress?: string;
  /** 任务佣金 */
  dutyCommission: number;
  /** 学历 */
  educational: EEducationLevel;
  /** 年龄要求 */
  age: EAgeRequirement;
  /** 年龄范围起 */
  startAge?: number;
  /** 年龄范围止 */
  endAge?: number;
  /** 性别要求 */
  sex: EGenderRequirement;
  /** 附件 */
  attachment: [];
  /** 任务时间 */
  dateRange: string[];
  /** 任务合同配置id */
  contractConfigId: number;
  /** 海南合同资料收集 */
  hainanContractCollectTime: EContractDataCollection;
  /** 业务类型 */
  dutyType?: EFreelancerDutyType;
  /** 开票种类 SPECIAL 增值税专票 GENERAL 增值税普票 */
  invoiceType?: EInvoiceType;
}

/**
 * 任务创建响应
 */
export interface ICreateTaskResponse {
  /** 响应码 */
  code: number;
  /** 响应内容 */
  context: Record<string, never>;
  /** 响应消息 */
  message?: string;
  /** 追踪ID */
  traceId?: string;
  /** 跨度ID */
  spanId?: string;
}

/**
 * 签约方式
 */
export enum ESignType {
  /** 0: 无感签约 */
  NoSign = 0,
  /** 1: 线上签约 */
  Online = 1,
}

export const signTypeLabel = {
  [ESignType.NoSign]: '无感签约',
  [ESignType.Online]: '线上签约',
};

/**
 * 是否
 */
export enum EYesNo {
  /** 0: 否 */
  No = 0,
  /** 1: 是 */
  Yes = 1
}

export const yesNoLabel = {
  [EYesNo.No]: '否',
  [EYesNo.Yes]: '是',
};

/**
 * 酬劳方式
 */
export enum ERenumerationType {
  /** 0: 面议 */
  Negotiable = 0,
  /** 1: 指定金额 */
  FixedAmount = 1,
  /** 2: 指定区间 */
  RangeAmount = 2
}

export const remunerationTypeLabel = {
  [ERenumerationType.Negotiable]: '面议',
  [ERenumerationType.FixedAmount]: '指定金额',
  [ERenumerationType.RangeAmount]: '指定区间',
};

/**
 * 任务地点类型
 */
export enum EDutyAddressType {
  /** 0: 全国 */
  Nationwide = 0,
  /** 1: 线上任务 */
  Online = 1,
  /** 2: 指定区域 */
  SpecificArea = 2
}

export const dutyAddressTypeLabel = {
  [EDutyAddressType.Nationwide]: '全国',
  [EDutyAddressType.Online]: '线上任务',
  [EDutyAddressType.SpecificArea]: '指定区域',
};

/**
 * 学历要求
 */
export enum EEducationLevel {
  /** 0: 不限 */
  Unlimited = 0,
  /** 1: 高中以下 */
  BelowHighSchool = 1,
  /** 2: 中专技校 */
  TechnicalSchool = 2,
  /** 3: 大学专科 */
  College = 3,
  /** 4: 大学本科 */
  Bachelor = 4,
  /** 5: 硕士研究生 */
  Master = 5,
  /** 6: 博士研究生 */
  Doctor = 6
}

export const educationalLabel = {
  [EEducationLevel.Unlimited]: '不限',
  [EEducationLevel.BelowHighSchool]: '高中以下',
  [EEducationLevel.TechnicalSchool]: '中专技校',
  [EEducationLevel.College]: '大学专科',
  [EEducationLevel.Bachelor]: '大学本科',
  [EEducationLevel.Master]: '硕士研究生',
  [EEducationLevel.Doctor]: '博士研究生',
};

/**
 * 年龄要求
 */
export enum EAgeRequirement {
  /** 0: 不限 */
  Unlimited = 0,
  /** 1: 请录入年龄区间 */
  AgeRange = 1
}

export const ageLabel = {
  [EAgeRequirement.Unlimited]: '不限',
  [EAgeRequirement.AgeRange]: '请录入年龄区间',
};

/**
 * 性别要求
 */
export enum EGenderRequirement {
  /** 0: 不限 */
  Unlimited = 0,
  /** 1: 男 */
  Male = 1,
  /** 2: 女 */
  Female = 2
}

export const genderLabel = {
  [EGenderRequirement.Unlimited]: '不限',
  [EGenderRequirement.Male]: '男',
  [EGenderRequirement.Female]: '女',
};

/**
 * 任务分页项
 */
export interface ITaskPageItem {
  /** 任务ID */
  id: number;
  /** 任务名称 */
  dutyName: string;
  /** 任务编号 */
  dutyNo: string;
  /** 任务类型 */
  tempName: string;
  /** 任务佣金 */
  dutyCommission: number;
  /** 产品编号 */
  code: string;

  /** 是否公开 */
  publicInMini: EYesNo;
  /** 任务开始时间 */
  startTime: string;
  /** 任务结束时间 */
  endTime: string;
  /** 任务状态 */
  status: ETaskStatus;
  /** 驳回原因 */
  rejectReason?: string;
  /** 海南开票方式 */
  hnInvoiceType?: EHnInvoiceType;
}

/**
 * 任务分页响应
 */
export interface ITaskPageResponse {
  /** 响应码 */
  code: number;
  /** 分页数据 */
  context: {
    /** 数据列表 */
    data: ITaskPageItem[];
    /** 总条数 */
    total: number;
  };
  /** 响应消息 */
  message?: string;
  /** 追踪ID */
  traceId?: string;
  /** 跨度ID */
  spanId?: string;
}

/**
 * 任务附件信息
 */
export interface ITaskAttachment {
  /** 文件名称 */
  fileName?: string;
  /** 文件类型 */
  fileType?: string;
  /** 文件URL */
  fileUrl?: string;
}

/**
 * 任务详情
 */
export interface ITaskDetail {
  /** 行业ID */
  industryId: number;
  /** 行业名称 */
  industryName: string;
  /** 适配职位名称 */
  positionName: string;
  /** 适配职位ID集合 */
  positionIds: number[];
  /** 任务类型说明 */
  tempDescription: string;
  /** 任务类型ID */
  tempId: string;
  /** 任务类型名称 */
  tempName: string;
  /** 任务名称 */
  dutyName: string;
  /** 任务开始时间 */
  startTime: string;
  /** 任务结束时间 */
  endTime: string;
  /** 产品编号 */
  code: string;
  /** 产品ID */
  productId: number;
  /** 产品名称 */
  productName: string;
  /** 开票科目名称 */
  invoiceSubName: string;
  /** 开票科目ID */
  invoiceSubId: number;
  /** 开票科目（服务商给企业）ID */
  hnInvoiceSubId: number;
  /** 开票科目（服务商给企业) 名称 */
  hnInvoiceSubName: string;
  /** 签约方式 */
  signType: ESignType;
  /** 任务内容说明 */
  description: string;
  /** 任务附件 */
  attachment: ITaskAttachment[];
  /** 是否在小程序公开 */
  publicInMini: EYesNo;
  /** 酬劳方式 */
  remunerationType: ERenumerationType;
  /** 起始金额 */
  startAmount?: number;
  /** 结束金额 */
  endAmount?: number;
  /** 任务地点类型 */
  dutyAddressType: EDutyAddressType;
  /** 任务所在区域 */
  dutyAddress?: string;
  /** 任务佣金 */
  dutyCommission: number;
  /** 学历要求 */
  educational: EEducationLevel;
  /** 年龄要求类型 */
  age: EAgeRequirement;
  /** 起始年龄 */
  startAge?: number;
  /** 结束年龄 */
  endAge?: number;
  /** 性别要求 */
  sex: EGenderRequirement;
  /** 需求人数 */
  jobNum: number;
  /** 是否需要报名 */
  signUpRequired: EYesNo;
  /** 任务合同 */
  contractName: string;
  /** 合同URL */
  contractUrl?: string;
  /** 海南合同资料收集 */
  hainanContractCollectTime: EContractDataCollection;
  /** 开票种类 SPECIAL 增值税专票 GENERAL 增值税普票 */
  invoiceType: EInvoiceType;
  /** 税源地类型 */
  taxSourceType?: ETaxSourceType;
  /** 合同模版id */
  contractTempId: number;
  /** 任务状态 */
  status: ETaskStatus;
  /** 收入性质 */
  proxyPayType?: EProxyPayType;
  /** 服务商名称 */
  serverName: string;
  /** 开票方式 */
  invoiceTaxMethod?: EInvoiceTaxMethod;
}

/**
 * 任务详情查询响应
 */
export interface ITaskDetailResponse {
  /** 响应码 */
  code: number;
  /** 任务详情 */
  context: ITaskDetail;
  /** 响应消息 */
  message?: string;
  /** 追踪ID */
  traceId?: string;
  /** 跨度ID */
  spanId?: string;
}

/**
 * 任务复制请求参数
 */
export interface ICopyTaskRequest {
  /** 任务ID */
  id: number;
  /** 新任务名称 */
  dutyName: string;
  /** 任务开始时间 */
  startTime: string;
  /** 任务结束时间 */
  endTime: string;
  /** 任务时间 */
  dateRange: string[];
}

/**
 * 人员信息导入请求参数
 */
export interface IReadTemplateParams {
  /** 任务id */
  dutyId: number;
  /** 模板附件url */
  templateUrl: string;
}

/**
 * 人员信息导入
 */
export interface IReadTemplate {
  /** 任务id */
  dutyId: number;
  /** 是否全部校验通过 0:否 1:是(计税前置校验用到) */
  status: number;
  /** 模版类型 0:银行卡-结算金额 1:银行卡-到账金额 2:支付宝-结算金额 3:支付宝-到账金额 */
  tempType: EDistributionTempType;
  /** 人员信息 */
  distributionPersonVOList: IDistributionPerson[];
  /** 海南异常人员列表 */
  errorHnPersonVOList: IDistributionPerson[];
}

export interface IDistributionPerson {
  /** 收款人 */
  personName?: string;
  /** 身份证号 */
  personIdNumber?: string;
  /** 银行卡号 */
  personBank?: string;
  /** 手机号 */
  personTel?: string;
  /** 结算金额 */
  settlementAmount?: number;
  /** 备注 */
  remark?: string;
  /** 是否重复 0:否 1:是 */
  repeatStatus?: ERepeatStatus;
  /** 校验结果 0:不通过 1:通过 */
  result?: EResult;
  /** 校验不通过原因 */
  errorMsg?: string;
  /** 是否超额 0:否 1:是 */
  excess?: number;
  /** 超额提醒内容	*/
  excessMsg?: string;
  /** 处理异常 0:不处理 1:处理 */
  dealErrorStatus?: EDealErrorStatus;
  /**  */
  name?: string;
  /**  */
  department?: string;
  /**  */
  idNumber?: string;
}

/**
 * 处理异常
 */
export enum EDealErrorStatus {
  /** 0: 不处理 */
  NOPASS = 0,
  /** 1: 处理 */
  PASS = 1
}

/**
 * 校验结果
 */
export enum EResult {
  /** 0: 不通过 */
  NOPASS = 0,
  /** 1: 已通过 */
  PASS = 1
}

export const resultLabel = {
  [EResult.NOPASS]: '不通过',
  [EResult.PASS]: '已通过',
};

export const resultStyle = {
  [EResult.NOPASS]: 'danger',
  [EResult.PASS]: 'success',
};

/**
 * 是否重复
 */
export enum ERepeatStatus {
  /** 0: 是 */
  YES = 1,
  /** 0: 否 */
  NO = 0
}

export interface ICalculateTaxesParams {
  /** 任务id */
  dutyId: number;
  /** 是否全部校验通过 0:否 1:是(计税前置校验用到) */
  status?: number;
  /** 模版类型 0:银行卡-结算金额 1:银行卡-到账金额 2:支付宝-结算金额 3:支付宝-到账金额 */
  tempType?: EDistributionTempType;
  /** 模板名称 */
  templateName?: string;
  /** 人员信息 */
  distributionPersonVOList: IDistributionPerson[];
}

export interface IOrderDetailAddMain {
  /** 任务id */
  dutyId: number;
  /** 模板名称 */
  templateName: string;
  /** 模版类型 0:银行卡-结算金额 1:银行卡-到账金额 2:支付宝-结算金额 3:支付宝-到账金额 */
  tempType?: EDistributionTempType;
  /** 服务商id */
  serverId?: number;
  /** 计税信息 */
  orderDetailAddVOList: IOrderDetailAdd[];
  /** 订单金额 */
  orderAmount: number;
  /** 结算金额 */
  settlementAmount: number;
  /** 成本金额(费用) */
  costAmount: number;
  /** 本次这个人总共发放金额 */
  totalMoney: number;
  /** 到账方式 0 银行卡 1支付宝 */
  receivedType?: number;
  /** 自然年派发是否限额 1:是 */
  isYearLimit: number;
  /** 自然年派发总和 */
  yearLimit: number;
  /** 自然年上限 */
  yearLimitMax: number;
}

export interface IOrderDetailAdd {
  /** 企业id */
  companyId?: number;
  /** 服务商id */
  serverId?: number;
  /** 品牌方id */
  agentId?: number;
  /** 个人信息id */
  customerId?: number;
  /** 个人名称 */
  personName?: string;
  /** 身份证号 */
  personIdNumber?: string;
  /** 银行卡号 */
  personBank?: string;
  /** 订单类型(0众包订单1立减金订单) */
  orderType?: EOrderType;
  /** 订单金额 */
  orderAmount?: number;
  /** 结算金额 */
  settlementAmount?: number;
  /** 完税开票金额 */
  taxableInvoiceAmount?: number;
  /** 企业服务费 */
  companyServiceAmount?: number;
  /** 个人服务费 */
  personServiceAmount?: number;
  /** 到账金额 */
  receivedAmount?: number;
  /** 服务费 */
  serviceAmount?: number;
  /** 税金 */
  taxAmount?: number;
  /** 计税金额 */
  tax?: number;
  /** 服务费率 */
  serviceRate?: number;
  /** 企业承担百分比 */
  companyProportion?: number;
  /** 个人承担百分比 */
  personalProportion?: number;
  /** 个税承担方(0?:企业1个人) */
  underTaker?: EUnderTaker;
  /** 本次这个人总共发放金额 */
  totalMoney?: number;
  /** 服务商成本费率 */
  serverServiceRate?: number;
  /** 服务商成本费用 */
  serverServiceAmount?: number;
  /** 特代授权费率 */
  authRate?: number;
  /** 特代授权费用 */
  authAmount?: number;
  /** 增值税 */
  addedTax?: number;
  /** 附加税总额 */
  additionalTaxMain?: number;
  /** 行为税 */
  behaviorTax?: number;
  /** 校验结果 0?:不通过 1?:通过 */
  result?: EResult;
  /** 校验不通过原因 */
  errorMsg?: string;
  /**  */
  orderDetailRateDto?: IOrderDetailRate;
  /** 手机号 */
  personTel?: string;
  /** 备注 */
  remark?: string;
}

export interface IOrderDetailRate {
  /** 费率id */
  rateDetailId?: number;
  /** 订单明细id */
  orderDetailId?: number;
  /** 授权品牌方Id */
  authAgentId?: number;
  /** 总服务费率 */
  totalRate?: number;
  /** 总服务费 */
  totalService?: number;
  /** 服务商服务费率 */
  serverRate?: number;
  /** 服务商服务费 */
  serverService?: number;
  /** 品牌方服务费率 */
  agentRate?: number;
  /** 品牌方服务费 */
  agentService?: number;
  /** 技术服务费率 */
  techRate?: number;
  /** 技术服务费 */
  techService?: number;
  /** 授权品牌方服务费率 */
  authAgentRate?: number;
  /** 授权品牌方服务费 */
  authAgentService?: number;
  /** 授权类型(0自有产品1授权产品) */
  authType?: number;
  /** 给一级代理商设置的服务费率 */
  levelOneRate?: number;
  /** 给一级代理商设置的服务费 */
  levelOneService?: number;
  /** 给二级代理商设置的服务费率 */
  levelTwoRate?: number;
  /** 给二级代理商设置的服务费 */
  levelTwoService?: number;
}

/**
 * 订单类型
 */
export enum EOrderType {
  /** 0: 众包订单 */
  CROWDSOURCED = 0,
  /** 1: 立减金订单 */
  DISCOUNT = 1
}

export const orderTypeLabel = {
  [EOrderType.CROWDSOURCED]: '众包订单',
  [EOrderType.DISCOUNT]: '立减金订单',
};

/**
 * 个税承担方
 */
export enum EUnderTaker {
  /** 0: 企业 */
  ENTERPRISE = 0,
  /** 1: 个人 */
  PERSON = 1
}

export const underTakerLabel = {
  [EUnderTaker.ENTERPRISE]: '企业',
  [EUnderTaker.PERSON]: '个人',
};

export interface IDutySignUpUserParams extends IPageParam{
  /** 任务id */
  id?: number;
  /** 姓名 */
  name?: string;
  /** 身份证号码 */
  idNo?: string;
  /** 手机号码 */
  phone?: string;
  /** 是否实名 */
  authStatus?: EIsRealName;
  /** 海南关系绑定 0:未入驻 1:已入驻 */
  hnTaxSourceStatus?: ETaxSourceLocation;
  /** 合同签署状态 0:未签署 1:已签署 2:完全签署 */
  contractSignatureStatus?: EFreelancerContractStatus;
  /** 报名方式 */
  signUpType?: ERegistrationMethod;
  /** 审核状态 - 待审批报名人员使用 */
  auditStatus?: string;
  /** 人脸核验 */
  faceAuthStatus?: EFaceAuth;
  /** 税务登记 */
  hnTaxStatus?: ETaxSourceRegister;
  /** 本人授权有效期 */
  inHnAuthTime?: boolean;
}

export interface IDutySignUpUser {
  /** 任务id */
  dutyId: string;
  /** 姓名 */
  name: string;
  /** 身份证号码 */
  idNo: string;
  /** 银行卡号 */
  cardNo: string;
  /** 手机号码 */
  phone: string;
  /** 是否实名 */
  authStatus: EIsRealName;
  /** 海南关系绑定 0:未入驻 1:已入驻 */
  hnTaxSourceStatus: ETaxSourceLocation;
  /** 合同签署状态 0:未签署 1:已签署 2:完全签署 */
  contractSignatureStatus: EFreelancerContractStatus;
  /** 报名方式 */
  signUpType: ERegistrationMethod;
  /** 合同签署方列表 */
  contractSignatoryList: IContractSignatory[];
}

export interface IContractSignatory {
  /** 签署方名称 */
  name: string;
  /** 签署方类型:SERVER|服务商 COMPANY|企业,可用值:SERVER,COMPANY */
  type: EContractSignatoryType;
  /** 合同签署状态 0:未签署 1:已签署 */
  contractSignatureStatus: EFreelancerContractStatus;
}

export enum EContractSignatoryType {
  /** 服务商 */
  SERVER = 'SERVER',
  /** 企业 */
  COMPANY = 'COMPANY'
}

export const contractSignatoryTypeLabel = {
  [EContractSignatoryType.SERVER]: '服务商',
  [EContractSignatoryType.COMPANY]: '企业',
};

export enum ERegistrationMethod {
  /** 小程序报名 */
  MINI = 0,
  /** 指派报名 */
  ASSIGN = 1
}

export const registrationMethodLabel = {
  [ERegistrationMethod.MINI]: '小程序报名',
  [ERegistrationMethod.ASSIGN]: '指派报名',
};

export interface ICalculateCommit {
  /**  */
  dutyDetail: ITaskDetail;
  /** 订单id */
  orderId: number;
  /** 订单总金额 */
  orderAmount: number;
  /** 总笔数 */
  totalNum: number;
  /** 结算总金额 */
  settlementAmount: number;
  /** 总服务费 */
  serviceAmount: number;
  /** 企业服务费 */
  companyServiceAmount: number;
  /** 个人服务费 */
  personServiceAmount: number;
  /** 总税金 */
  taxAmount: number;
  /** 到账总金额(个人到账金额) */
  receivedAmount: number;
  /** 成功金额 */
  successAmount: number;
  /** 失败金额 */
  failureAmount: number;
}

export enum EContractDataCollection {
  /** 在派发前 */
  BEFORE_DISTRIBUTE = 0,
  /** 在开票前 */
  BEFORE_INVOICING = 1
}

export const contractDataCollectionLabel = {
  [EContractDataCollection.BEFORE_DISTRIBUTE]: '在派发前',
  [EContractDataCollection.BEFORE_INVOICING]: '在开票前',
};

export enum EBindEmployeeStatus {
  /** 未绑定 */
  BEFORE_DISTRIBUTE = 0,
  /** 已绑定 */
  BEFORE_INVOICING = 1
}

export interface IDealErrorPersonParams {
  /** 任务id	 */
  dutyId: number;
  /** 模版类型 0:银行卡-结算金额 1:银行卡-到账金额 2:支付宝-结算金额 3:支付宝-到账金额 */
  tempType?: number;
  /**  */
  personVOList: IDistributionPerson[];
}

export enum EInvoiceType {
  /** 增值税专票 */
  SPECIAL = 'SPECIAL',
  /** 增值税普票 */
  GENERAL = 'GENERAL'
}

export const invoiceTypeLabel = {
  [EInvoiceType.SPECIAL]: '增值税专票',
  [EInvoiceType.GENERAL]: '增值税普票',
};

export interface IDutyDistributionTempParams {
  /** 个人到账方式 0:支付宝 1:银行卡 */
  paymentMethod: EPaymentMethod;
  /** 发放类型 0:结算金额 1:到账金额 */
  distributionType?: EDistributionType;
  /** excel模版类型 0:空模版 1:带报名人员信息模版 */
  excelTempType?: EExcelTempType;
  /** 任务id(必传) */
  id: number;
}

export enum EPaymentMethod {
  /** 支付宝 */
  ALIPAY = 0,
  /** 银行卡 */
  BANK = 1
}

export const paymentMethodLabel = {
  [EPaymentMethod.ALIPAY]: '支付宝',
  [EPaymentMethod.BANK]: '银行卡',
};

export enum EDistributionType {
  /** 结算金额 */
  SETTLEMENT = 0,
  /** 到账金额 */
  RECEIVED = 1
}

export const distributionTypeLabel = {
  [EDistributionType.SETTLEMENT]: '结算金额（按个人实得+个税结算）',
  [EDistributionType.RECEIVED]: '到账金额（按个人实得结算）',
};

export enum EExcelTempType {
  /** 空模版 */
  EMPTY = 0,
  /** 带报名人员信息模版 */
  INFO = 1
}

export const excelTempTypeLabel = {
  [EExcelTempType.EMPTY]: '不含报名人员',
  [EExcelTempType.INFO]: '含报名人员',
};

export enum EDistributionTempType {
  /** 银行卡-结算金额 */
  BANK_SETTLEMENT = 0,
  /** 银行卡-到账金额 */
  BANK_RECEIVED = 1,
  /** 支付宝-结算金额 */
  ALIPAY_SETTLEMENT = 2,
  /** 支付宝-到账金额 */
  ALIPAY_RECEIVED = 3,
}

export interface IDutyDeliver {
  /** 交付物ID */
  id: number;
  /** 任务ID */
  dutyId: number;
  /** 交付物类型 0:任务总交付物 */
  type: EDutyDeliverType;
  /** 上传日期 格式 yyyy-MM-dd */
  createTime: string;
  /** 交付说明 */
  remark: string;
  /** 交付物 */
  delieversList: ITaskAttachment[];
  /** 状态 0:未上传 1:待审批 2:已通过 3:已驳回 */
  status: number;
  /** 操作人 */
  updater: string;
  /** 任务名称 - 详情接口有 */
  dutyName?: string;
  /** 更新日期 格式 yyyy-MM-dd */
  uploadTime?: string;
}

export interface IDutyDeliverUploadParams {
  /** 任务ID */
  dutyId: number;
  /** 操作类型 0:上传交付物 1:重新上传 */
  operateType: number;
  /**  */
  id: number;
  /** 交付说明 */
  remark: string;
  /** 交付物 */
  deliverFileList: ITaskAttachment[];
}

export enum EDutyDeliverType {
  /** 任务总交付物 */
  All = 0
}

export const dutyDeliverTypeConfig = { [EDutyDeliverType.All]: '任务总交付物' };

export enum EDutyDeliverStatus {
  /** 未上传 */
  NOT_UPLOADED = 0,
  /** 待审批 */
  PENDING_APPROVAL = 1,
  /** 已通过 */
  PASSED = 2,
  /** 已驳回 */
  REJECTED = 3
}

export const dutyDeliverStatusConfig = {
  [EDutyDeliverStatus.NOT_UPLOADED]: '未上传',
  [EDutyDeliverStatus.PENDING_APPROVAL]: '待审批',
  [EDutyDeliverStatus.PASSED]: '已通过',
  [EDutyDeliverStatus.REJECTED]: '已驳回',
};

export const dutyDeliverStatusStyle = {
  [EDutyDeliverStatus.NOT_UPLOADED]: 'info',
  [EDutyDeliverStatus.PENDING_APPROVAL]: 'primary',
  [EDutyDeliverStatus.PASSED]: 'success',
  [EDutyDeliverStatus.REJECTED]: 'danger',
};

/** 税费计算器请求参数 */
export interface ITaxCalculatorRequest {
  /** 产品id */
  productId: number;
  /** 企业id */
  companyId?: number;
  /** 结算方式 0:到账金额（按个人实得结算 1:结算金额（按个人实得+个税结算） */
  settlementType: number;
  /** 到账金额/结算金额 */
  money: number;
}

/** 税费计算结果 */
export interface ITaxCalculatorDetail {
  /** 企业应支付金额 */
  orderAmount: number;
  /** 自由职业者到账金额 */
  receivedAmount: number;
  /** 税金 */
  taxAmount: number;
  /** 服务费 */
  serviceAmount: number;
}

export const publicInMiniLabel = {
  [EYesNo.Yes]: '公开',
  [EYesNo.No]: '不公开',
};

export const signUpRequiredLabel = {
  [EYesNo.Yes]: '报名',
  [EYesNo.No]: '无需报名',
};

export interface IDutySignUpUserNonAudit {
  /** 任务id */
  dutyId: string;
  /** 姓名 */
  name: string;
  /** 身份证号码 */
  idNo: string;
  /** 银行卡号 */
  cardNo: string;
  /** 手机号码 */
  phone: string;
  /** 审批编号 */
  taskNo: string;
}

export interface IHnLimit {
  /** 海南通知 */
  HnNotice: number;
  /** 海南限制 */
  HnLimit: number;
  /** 海南已派发金额 */
  HnAmount: number;
}
